/**
 *  for accurate rounding of numbers
 *  https://stackoverflow.com/questions/3108986/gaussian-bankers-rounding-in-javascript
 *
 */
export const gaussRound = function (num, decimalPlaces) { // eslint-disable-line
  /* eslint-disable */
  let d = decimalPlaces || 0;
  let m = Math.pow(10, d);
  let n = +(d ? num * m : num).toFixed(8);
  let i = Math.floor(n);
  let f = n - i;
  let e = 1e-8;
  let r = (f > 0.5 - e && f < 0.5 + e) ? ((i % 2 == 0) ? i : i + 1) : Math.round(n);

  return parseFloat(d ? r / m : r);
}


// WEBPACK FOOTER //
// ./src/shared/utils/helpers/gaussRound.js